import { InvoicePaidByType } from '@seapoint/server/enums';
import { exhaustiveCheck } from '../../../../../utils/exhaustive-check';

export type PaidInvoiceMatchingStatus = 'Unknown' | 'Automatched' | 'Manually matched' | 'Paid via Seapoint';

export const getPaidInvoiceMatchingStatus = (
  isPaidUpdatedByType: InvoicePaidByType | undefined,
): PaidInvoiceMatchingStatus => {
  if (!isPaidUpdatedByType) {
    return 'Unknown';
  }

  switch (isPaidUpdatedByType) {
    case InvoicePaidByType.SYSTEM:
      return 'Automatched';
    case InvoicePaidByType.USER:
      return 'Manually matched';
    case InvoicePaidByType.PAYMENT:
      return 'Paid via Seapoint';
    default:
      return exhaustiveCheck(isPaidUpdatedByType);
  }
};
